export default {
  text: 'Ao utilizar este website, concorda com a nossa',
  cookie_policy: 'Política de Cookies.',
  buttons: {
    accept: 'Aceitar',
    reject: 'Rejeitar',
  },
};
